const mFeedSectionContentCardEditionDesign4 = {
  mFeedSectionContentCardEditionDesign4: {
    infoPrice: {
      buy: 'COMPRAR',
      free: 'GRATIS',
      noprice: 'SIN PRECIO'
    },

    messages: {
      aspectRatio: '* Relación de aspecto de imagen: 16:9',
      genericParagraph: 'Aquí podrás incluir una descripción acerca de las características de cada curso incluido en este producto.',
      dimensions: '* Tamaño sugerido de imagen: 99px de ancho por 55,69px de alto',
      extensions: '* Formatos permitidos de imagen: .gif .jpg .png',
      nameLength: '* Longitud permitida de nombre: de 5 a 120 caracteres',
      textsLength: '* Longitud permitida en los 3 textos: hasta 120 caracteres'
    },

    validation: {
      fileExtension: 'Extensión de imagen no permitida.',
      fileSize: 'Tamaño de imagen no permitido.',
      fileRequired: 'Todas las imagenes son requeridas.',

      nombre: {
        maxLength: 'La longitud máxima permitida de nombre es de 120 caracteres.',
        minLength: 'La longitud mínima permitida de nombre es de 5 caracteres.',
        required: 'Nombre de producto es requerido. De 5 a 120 caracteres.'
      },

      textLength: 'Longitud permitida de texto: hasta 120 caracteres.',
      textRequired: 'Todos los textos son requeridos.'
    }
  }
}

export default mFeedSectionContentCardEditionDesign4
